import { useEffect, useState } from "react";
import { fetchAPI, getStrapiMedia } from "../../utils/api";

const PortfolioOne = () => {
  const [portfolioItems, setPortfolioItems] = useState([]);

  useEffect(() => {
    const getProjects = async () => {
      try {
        const projects = await fetchAPI('/works', {
          populate: ['image', 'categories']
        });
        if (projects.data) {
          const mappedProjects = projects.data.map(item => {
            return {
              id: item.id,
              documentId: item.documentId,
              title: item.title,
              image: getStrapiMedia(item.image),
              categories: item.categories ? item.categories.map(cat => cat.name) : []
            };
          });
          setPortfolioItems(mappedProjects);
        }
      } catch (error) {
        console.error("Error fetching projects:", error);
      }
    };
    getProjects();
  }, []);

  if (!portfolioItems.length) return null;

  return (
    <div className="row">
      <div className="stack-wrapper">
        {portfolioItems.map((item) => (
          <div className="stack-item" key={item.id}>
            <div className="card portfolio-item layout-2 scale has-shadow">
              <div className="image-holder">
                <a className="card-thumb" href={`/work/${item.documentId}`}>
                  <img src={item.image} alt={item.title} />
                </a>
                <div className="card-overlay">
                  <div className="heading">
                    <h4 className="title mt-2 mt-md-3 mb-3">{item.title}</h4>
                    <div className="show-project">
                      <div className="card-terms">
                        {item.categories.map((category, index) => (
                          <a className="terms badge outlined" href="/portfolio" key={index}>
                            {category}
                          </a>
                        ))}
                      </div>
                      <div className="project-link">
                        <a href={`/work/${item.documentId}`}>Show Project</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PortfolioOne;

